import { render, staticRenderFns } from "./ScanRecordList.vue?vue&type=template&id=6eb841b5&"
import script from "./ScanRecordList.vue?vue&type=script&lang=js&"
export * from "./ScanRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports